import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      id: item.task_id,
      status: item.status,
      created_at: item.created_at,
      updated_at: item.updated_at,
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getSendbirdBatchMessages({ payload: { signal, searchQ, curr_page } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.sendbird.multi_message.list,
      params: {
        page: curr_page,
        q: searchQ,
        ordering: '-created_at'
      },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getSendbirdBatchMessagesDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getSendbirdBatchMessagesFailed,
      endpoint: api.sendbird.multi_message.list.url
    });
  }
}

export const getSendbirdBatchMessagesSaga = takeEvery(types.GET_SENDBIRD_BATCH_MESSAGES_REQUEST, getSendbirdBatchMessages);